export type ThrowPose = 'reach' | 'hold' | 'release' | 'recover'
export type ThrowEvent = 'grab' | 'emerge' | 'release'

export interface ThrowClipFrame {
  pose: ThrowPose
  frame: number
  durationMs: number
  events: readonly ThrowEvent[]
}

export interface ThrowClipSpec {
  sheetKey: string
  path: string
  frameWidth: number
  frameHeight: number
  localX: number
  localY: number

  frames: readonly ThrowClipFrame[]
  projectileSheetKey: string
  impactSheetKey: string
}

export const HONEY_THROW_CLIP = {
  sheetKey: 'tower-v2-honey-throw-4way',
  path: 'sprites/v2/honey/bear-honey-throw-4way.png',
  frameWidth: 128,
  frameHeight: 128,
  localX: 0,
  localY: 0,

  frames: [
    { pose: 'reach', frame: 0, durationMs: 120, events: [] },
    { pose: 'hold', frame: 1, durationMs: 160, events: ['grab', 'emerge'] },
    { pose: 'release', frame: 2, durationMs: 100, events: [] },
    { pose: 'recover', frame: 3, durationMs: 140, events: ['release'] },
  ],
  projectileSheetKey: 'tower-v2-honey-fish-swim',
  impactSheetKey: 'tower-v2-honey-impact',
} as const satisfies ThrowClipSpec

const THROW_CAPABILITIES: Readonly<Record<string, ThrowClipSpec>> = Object.freeze({
  honey: HONEY_THROW_CLIP,
})

export function getThrowCapability(archetype: string): ThrowClipSpec | null {
  return Object.hasOwn(THROW_CAPABILITIES, archetype) ? THROW_CAPABILITIES[archetype] : null
}
